import React from 'react';
import get from 'lodash/get';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../../CommonComponents/OPL/Select/Select/Select';
import { OptionType } from '../../../CommonComponents/OPL/Select/BaseSelect/types';

interface Props {
  formKey?: string;
  options: OptionType<string>[];
}

export const ExistingAccount = ({
  formKey = 'ExcessCashFlowStrategy.data.existingAccountId',
  options,
}: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = get(errors, formKey);

  return (
    <Controller
      control={control}
      name={formKey}
      render={({ field: { value, onChange } }) => {
        return (
          <Select
            isPortal
            value={options.find(({ value: _val }) => value === _val)}
            options={options}
            onChange={opt => {
              onChange(opt?.value);
            }}
            formVariant={error && 'error'}
            helperText={error?.message}
          />
        );
      }}
    />
  );
};
